import React, {useState} from "react";
import './CheckLanguage.css';
import flag_rus from "../../../../static/img/Header/flag_rus.png";
import flag_en from "../../../../static/img/Header/flag_en.png";
import flag_cn from "../../../../static/img/Header/BO_china.png";
import langActive from "../../../../static/img/Header/langActiveNew.svg";
import Cookies from 'universal-cookie';
import ChangeLink from "../../../ChangeLink/ChangeLink";
const cookies = new Cookies();

const ArrLanguages = {
    ru : {img: flag_rus, langLink: '/ru', Title: 'RUS',lang: 'ru'},
    en : {img: flag_en, langLink: '', Title: 'ENG',lang: 'en'},
    cn : {img: flag_cn, langLink: '/cn', Title: 'CHN',lang: 'cn'},
};

function  CheckLanguage(props){
    const [VisibleCheckLanguage, setVisibleCheckLanguage] = useState('CheckLanguageNo');
    const [VisibleAllDark, setVisibleAllDark] = useState('StandartNotVisible');

    function ChangeCheckLanguageVisible(VisibleCheckLanguage, VisibleAllDark,LangForCookies) {
        cookies.set('lang', LangForCookies, { path: '/' });
        //console.log('lang ChangeCheckLanguageVisible ',cookies.get('lang'));
        setVisibleCheckLanguage(VisibleCheckLanguage);
        setVisibleAllDark(VisibleAllDark);
    }
    function SetAllInVisible() {setVisibleCheckLanguage('CheckLanguageNo');setVisibleAllDark("StandartNotVisible");}

        let LangUse;
        if (props.lang === 'en' || props.lang === 'ru' || props.lang === 'cn') {LangUse = props.lang}  else {LangUse = 'en'}
        let PathWithoutLanguage ;

        if (typeof window !== 'undefined') {//Если третий элемент / значит язык есть - а если нет - то значит мы на английском языке и надо вырезать с первого элемента
            if (window.location.pathname.substr(3,1) === '/' || window.location.pathname.substr(3,1) === '' ) {PathWithoutLanguage = window.location.pathname.substr(3,window.location.pathname.length)}
            else {PathWithoutLanguage = window.location.pathname.substr(0,window.location.pathname.length)}
        }
        // let DopHrefIndexEn = '';
        // if (props.index){DopHrefIndexEn = 'en/'}
        let propsLang = props.lang;
        const ArrLanguagesMap = Object.keys(ArrLanguages).map((element,index) =>
            // <ChangeLink key={index} to={(((ArrLanguages[element].langLink === '') ? ArrLanguages[element].langLink + DopHrefIndexEn: ArrLanguages[element].langLink)+PathWithoutLanguage)} role = "button" tabIndex={0} onClick={() => ChangeCheckLanguageVisible('CheckLanguageNo','StandartNotVisible',ArrLanguages[element].lang)}>
            <ChangeLink key={index} to={PathWithoutLanguage} lang={element} role = "button" tabIndex={0} onClick={() => ChangeCheckLanguageVisible('CheckLanguageNo','StandartNotVisible',ArrLanguages[element].lang)}>
                <div className="CheckLanguage CheckLanguageHover">
                    <div className="CheckLanguageImg"><img alt='Ifyoudontseeimages' src={ArrLanguages[element].img} width='28px' height='20px'/></div>
                    <div className="CheckLanguageTitle"><nobr>{ArrLanguages[element].Title}</nobr></div>
                    <div className={(propsLang === ArrLanguages[element].lang) ? "LangActive" : 'LangNoActive'}>
                    <img alt='Ifyoudontseeimages' src={langActive} width='20px' height='13px'/>
                    </div>
                </div>
            </ChangeLink>
        );

        return (
            <div className="CheckLanguageOutOut">
                <div className={"AllBlack " + VisibleAllDark}  onClick={() => SetAllInVisible()} role="button" tabIndex={0}> </div>
                <div className={"CheckLanguageOut " + VisibleCheckLanguage} >
                    <div className={"CheckLanguageNoVisible " + VisibleAllDark} onClick={() => ChangeCheckLanguageVisible('CheckLanguageNo','')} role="button" tabIndex={0}> </div>
                    {ArrLanguagesMap}
                </div>
                <div className="CheckLanguage"  role = "button" tabIndex={0} onClick={() => ChangeCheckLanguageVisible('CheckLanguageYes')}>
                    <div className="CheckLanguageImg"><img alt='Ifyoudontseeimages' src={ArrLanguages[props.lang || 'en'].img} width='14px'/></div>
                    <div className="CheckLanguageTitle">{ArrLanguages[LangUse].Title}</div>
                </div>
            </div>
        )}

export default CheckLanguage

